var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-health-1{fill:#fff;}.cls-health-1,.cls-health-2{fill-rule:evenodd;}.cls-health-2,.cls-health-5{fill:#aecbfa;}.cls-health-3{mask:url(#mask);}.cls-health-4{fill:#4285f4;}.cls-health-6{fill:#669df6;}\n        "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 9.33,
    y: 5.33,
    width: 5.33,
    height: 16.67,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-health-1",
    points: "12 22 11.17 21.23 11.17 6.67 12.83 6.67 12.83 21.23 12 22"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_HealthcareAPI_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-health-2",
    points: "12 22 11.17 21.23 11.17 6.67 12.83 6.67 12.83 21.23 12 22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-health-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-health-4",
    d: "M12,8a2.67,2.67,0,0,0,2.67-2.67H9.33A2.67,2.67,0,0,0,12,8Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-2",
    className: "cls-health-4",
    points: "12.83 18.87 11.17 18.87 11.17 17.33 12.83 17.33 12.83 18.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-health-4",
    points: "12.83 10.87 11.17 10.87 11.17 9.33 12.83 9.33 12.83 10.87"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-health-5",
    cx: 12,
    cy: 4.67,
    r: 2.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-health-6",
    d: "M16.67,10.17H6.83a1.17,1.17,0,0,0,0,2.33H10v1.67H6.83a2.84,2.84,0,0,1,0-5.67h9.84V7.33l3.33,2-3.33,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-health-6",
    d: "M12,7.33a2.67,2.67,0,0,0,2.67-2.66H9.33A2.67,2.67,0,0,0,12,7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-health-6",
    d: "M13.36,16.5H14a1.17,1.17,0,0,0,0-2.33H12.83V12.5H14a2.84,2.84,0,0,1,0,5.67H10v1.16l-3.33-2,3.33-2V16.5Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.698ea820cee64f30368a761d6ccb6b94.svg";
export { ForwardRef as ReactComponent };